import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleFetchLogisticDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchLogisticDetails, payload);
    const { data } = res;
    yield put(actions.fetchLogisticDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLogisticDetailsFailure(err?.response?.data));
  }
}

export function* handleEditLogistic({ payload }) {
  try {
    const res = yield call(APIS.editLogistic, payload.data);
    const { data } = res;
    yield put(actions.updateLogisticSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateLogisticFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateLogisticFailure(err?.response?.data));
    payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* logisticEditSaga() {
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(
    actions.fetchLogisticDetails.type,
    handleFetchLogisticDetails
  );
  yield takeLatest(actions.updateLogistic.type, handleEditLogistic);
}
